export const CloseBtnIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.6692 5.97189L14.5274 4.83008L10.0006 9.35684L5.47384 4.83008L4.33203 5.97189L8.85879 10.4986L4.33203 15.0254L5.47384 16.1672L10.0006 11.6405L14.5274 16.1672L15.6692 15.0254L11.1424 10.4986L15.6692 5.97189Z"
        fill="white"
      />
    </svg>
  );
};
